import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import * as hooks from '@owl-nest/hooks'

import type { TileData } from './Tile'

const SIZE_IMAGE_ITEM = {
  height: 494,
  width: 338,
}

export function RotativeCard({
  data,
  activeIndex,
}: {
  data: (TileData & { imgSrc: string })[]
  activeIndex: number | undefined
}): React.ReactElement {
  const rotation = useRotativeImage(activeIndex ?? 0)

  return (
    <RotativeImage rotation={rotation}>
      {data.map((item, i) => (
        <ds.Picture
          key={i}
          src={item.imgSrc}
          height={SIZE_IMAGE_ITEM.height}
          width={SIZE_IMAGE_ITEM.width}
          style={{ opacity: activeIndex === i ? 1 : 0 }}
        />
      ))}
    </RotativeImage>
  )
}

function useRotativeImage(activeIndex: number): number {
  const stableRandomValue = hooks.useRandom(activeIndex)

  return stableRandomValue * 9 - 4.5
}

const RotativeImage = styled.div<{ rotation: number }>`
  position: absolute;
  top: 220px;
  left: 50%;
  width: 224px;
  transform: translate(-50%, -50%) rotate(${({ rotation }) => rotation}deg);
  transition: transform 0.3s;
  border-radius: 9px;
  overflow: hidden;
  z-index: 1;

  &:before {
    content: '';
    display: block;
    padding-bottom: ${(SIZE_IMAGE_ITEM.height / SIZE_IMAGE_ITEM.width) * 100}%;
  }

  &:after {
    background-color: #000;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0.2;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${ds.Picture} {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    img {
      transition: opacity 0.2s;
    }
  }

  @media screen and (${ds.breakpoint.MOBILE_L}) {
    width: 280px;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    top: 260px;
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    width: 318px;
  }
`
